import axios from 'util/axiosConfig';
import { getErrorMessage } from '../util/ErrorUtils';

export const fetchDiagramTemplatesAPI = async () => {
    return await axios.post(`/api/v1/diagram-templates`)
        .then(function (response) {
            if (response.data) {
                console.log('here', response.data)
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const addUpdateDiagramTemplateAPI = async (diagramTemplate) => {

    const formData = new FormData();
    formData.append('name', diagramTemplate.name);
    formData.append('shortName', diagramTemplate.shortName);
    formData.append('description', diagramTemplate.description);
    if (diagramTemplate.file) {
        formData.append('file', diagramTemplate.file);
    }
    if (diagramTemplate.directory1) {
        formData.append('directory1', diagramTemplate.directory1);
    }
    if (diagramTemplate.directory2) {
        formData.append('directory2', diagramTemplate.directory2);
    }
    formData.append('diagramTemplateId', diagramTemplate.diagramTemplateId);
    return await axios.post(`/api/v1/diagram-template`, formData)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const deleteDiagramTemplateAPI = async (diagramTemplateId) => {
    return await axios.delete(`/api/v1/diagram-template/${diagramTemplateId}`, diagramTemplateId)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchPublicCategorizedDiagramTemplatesAPI = async () => {
    return await axios.get(`/api/v1/public-diagram-templates`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getDiagramStageJson = async (url) => {
    return await axios.post(`/api/v1/reports/diagrams/json`, {
        url: url
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const addUpdateDiagramAPI = async (data) => {
    var formData = new FormData();
    formData.append('file', data.file);
    formData.append('reportId', data.reportId);
    formData.append('diagramId', data.diagramId);
    return await axios.post(`/api/v1/reports/${data.reportId}/diagrams`, formData)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const deleteReportDiagramsAPI = async ({ reportId, diagramId }) => {
    return await axios.delete(`/api/v1/reports/${reportId}/diagrams/${diagramId}`)
        .then(function (response) {
            if (response.data) {
                return { success: response.data };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getReportDiagramsAPI = async (reportId) => {
    return await axios.get(`/api/v1/reports/${reportId}/diagrams`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchGroupDiagramTemplatesAPI = async () => {
    return await axios.get(`/api/v1/group-diagram-templates`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}